/**
 * THIS IS AN AUTO-GENERATED FILE FROM SVGR. DO NOT MODIFY!
 *
 * File was made using the 'rushx build:icons' command.
 * To learn more see the {@link https://github.com/seequent/user-portal/blob/master/libraries/web-design-system-2/README.md#making-icons-|ReadMe}
 */
import SvgIcon from '@mui/material/SvgIcon';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { createElement } from 'react';

function SvgWarningIcon(props: SvgIconProps) {
    return createElement(
        SvgIcon,
        { style: { width: '1em', height: '1em' }, viewBox: '0 0 24 24', ...props },
        <path
            fill="currentColor"
            fillOpacity={0.9}
            fillRule="evenodd"
            d="M1.294 18.206C.286 19.873 1.486 22 3.434 22h17.133c1.947 0 3.147-2.127 2.14-3.794L14.138 4.038c-.972-1.608-3.306-1.608-4.278 0zm1.711 1.035a.5.5 0 0 0 .428.759h17.134a.5.5 0 0 0 .428-.759L12.428 5.073a.5.5 0 0 0-.856 0zM11 17.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5-7.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"
            clipRule="evenodd"
        />,
    );
}
export default SvgWarningIcon;
